// $(document).ready(() => {
//   let popupShown = false;

//   $(document).on('mouseleave', (e) => {
//     if (e.clientY <= 0 && !popupShown) {
//       $('.exit-intent-popup-section').fadeIn(300);
//       popupShown = true; // prevent multiple triggers
//     }
//   });

//   // Close popup on click of close button
//   $('.exit-intent-popup-section .close-btn').on('click', () => {
//     $('.exit-intent-popup-section').fadeOut(200);
//   });

//   // Close popup on outside click
//   $('.exit-intent-popup-section').on('click', (e) => {
//     if (!$(e.target).closest('.exit-intent-popup .container .row').length) {
//       $('.exit-intent-popup-section').fadeOut(200);
//     }
//   });
// });

// $(document).ready(() => {
//   const $popupSection = $('.exit-intent-popup-section');
//   const $popupContent = $('.exit-intent-popup-section .exit-intent-popup .container .row');
//   const $closeBtn = $('.exit-intent-popup-section .close-btn');

//   // Show popup after 3 minutes
//   setTimeout(() => {
//     $popupSection.fadeIn(300);
//   }, 180000); // 3 minutes = 180,000 milliseconds

//   // Close on close button click
//   $closeBtn.on('click', (e) => {
//     e.stopPropagation();
//     $popupSection.fadeOut(200);
//   });

//   // Close on outside click
//   $popupSection.on('click', (e) => {
//     if (!$(e.target).closest($popupContent).length) {
//       $popupSection.fadeOut(200);
//     }
//   });
// });

$(document).ready(() => {
  const $popupSection = $('.exit-intent-popup-section');
  const $popupContent = $('.exit-intent-popup-section .exit-intent-popup .container .row');
  const $closeBtn = $('.exit-intent-popup-section .close-btn');

  const COOKIE_NAME = 'exit_intent_popup_seen';
  const COOKIE_DAYS = 7;

  // Helper: set cookie
  function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }

  // Helper: get cookie
  function getCookie(name) {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  }

  // Only trigger if cookie not set
  if (!getCookie(COOKIE_NAME)) {
    setTimeout(() => {
      $popupSection.fadeIn(300);
    }, 180000); // 3 minutes
  }

  // Function to close + set cookie
  function closePopup() {
    $popupSection.fadeOut(200);
    setCookie(COOKIE_NAME, "true", COOKIE_DAYS); // set cookie only when closed
  }

  // Close on close button click
  $closeBtn.on('click', (e) => {
    e.stopPropagation();
    closePopup();
  });

  // Close on outside click
  $popupSection.on('click', (e) => {
    if (!$(e.target).closest($popupContent).length) {
      closePopup();
    }
  });
});
